<template>
  <div>
    <div id="fm_main_container">
      <container>
      <!-- Depending on Some Shortcodes - either one of the display will dynamically load - lets start with the sidebar by default -->
      <fm_display_simple v-if="displayToUse == 'simple'" :show_results_per_page_selector="show_results_per_page_selector" :resultColumns="1"></fm_display_simple>
      <fm_display_simple v-else-if="displayToUse == 'simple2columns'" :show_results_per_page_selector="show_results_per_page_selector" :resultColumns="2"></fm_display_simple>
      <fm_display_sidebar v-else :show_results_per_page_selector="show_results_per_page_selector" :resultColumns="1"></fm_display_sidebar>
      </container>
    </div>
  </div>
</template>

<script>
import DisplaySidebar from './DisplaySidebar.vue';
import DisplaySimple from './DisplaySimple.vue';


export default {
  components: {
    'fm_display_sidebar': DisplaySidebar,
    'fm_display_simple': DisplaySimple
  },
  data(){
    return {
      displayToUse: 'sidebar', //if all things go right - overwritten by PHP and/or shortcode
      show_results_per_page_selector: true, //if all things go right - overwritten by PHP and/or shortcode
    }
  },
  methods: {

  },
  computed: {

  },
  created(){
    //set display to use value
    const wpDisplay = wpData.fm_display;
    //console.log(wpDisplay);
    this.displayToUse = wpDisplay;

    this.show_results_per_page_selector = wpData.fm_num_results_per_page_selector;
    //console.log('Show if selector bar is on: ' + wpData.fm_num_results_per_page_selector);

    //set num results per page
    //update the number of results per page ... this value come from the shortcode
    this.$store.dispatch('setMPPNumResPerPageSelected', wpData.fm_num_results_per_page);
    //console.log('Results per page are set.' +  wpData.fm_num_results_per_page);
  }
}
</script>

<style scoped lang="scss">

</style>